var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{staticClass:"score-table",attrs:{"columns":_vm.columns,"data-source":_vm.data,"bordered":"","pagination":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }